var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_897_39645)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.4327 7.87636C13.005 6.77005 12.2626 5.81332 11.297 5.12439C10.3315 4.43547 9.18528 4.04457 8.00001 4C6.81475 4.04457 5.66852 4.43547 4.703 5.12439C3.73747 5.81332 2.99498 6.77005 2.56729 7.87636C2.5384 7.95626 2.5384 8.04374 2.56729 8.12364C2.99498 9.22995 3.73747 10.1867 4.703 10.8756C5.66852 11.5645 6.81475 11.9554 8.00001 12C9.18528 11.9554 10.3315 11.5645 11.297 10.8756C12.2626 10.1867 13.005 9.22995 13.4327 8.12364C13.4616 8.04374 13.4616 7.95626 13.4327 7.87636ZM8.00001 11.2727C6.07274 11.2727 4.03638 9.84364 3.2982 8C4.03638 6.15636 6.07274 4.72727 8.00001 4.72727C9.92729 4.72727 11.9637 6.15636 12.7018 8C11.9637 9.84364 9.92729 11.2727 8.00001 11.2727Z",
    fill: "#161616"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.00001 5.81818C7.56849 5.81818 7.14666 5.94614 6.78786 6.18588C6.42906 6.42563 6.14941 6.76638 5.98428 7.16505C5.81914 7.56373 5.77593 8.00242 5.86012 8.42565C5.94431 8.84888 6.1521 9.23765 6.45724 9.54278C6.76237 9.84791 7.15113 10.0557 7.57436 10.1399C7.99759 10.2241 8.43629 10.1809 8.83496 10.0157C9.23364 9.8506 9.57439 9.57095 9.81413 9.21215C10.0539 8.85336 10.1818 8.43152 10.1818 8C10.1818 7.42135 9.95196 6.86639 9.54279 6.45722C9.13362 6.04805 8.57867 5.81818 8.00001 5.81818ZM8.00001 9.45455C7.71233 9.45455 7.43111 9.36924 7.19191 9.20941C6.95271 9.04958 6.76628 8.82241 6.65619 8.55663C6.5461 8.29085 6.51729 7.99839 6.57342 7.71623C6.62954 7.43408 6.76807 7.1749 6.9715 6.97148C7.17492 6.76806 7.43409 6.62953 7.71625 6.5734C7.9984 6.51728 8.29086 6.54608 8.55664 6.65618C8.82243 6.76627 9.0496 6.9527 9.20942 7.1919C9.36925 7.4311 9.45456 7.71232 9.45456 8C9.45456 8.38577 9.30131 8.75574 9.02853 9.02852C8.75575 9.3013 8.38578 9.45455 8.00001 9.45455Z",
    fill: "#161616"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_897_39645"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11.6364,
    height: 11.6364,
    fill: "white",
    transform: "translate(2.18182 2.18164)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgView);
export default __webpack_public_path__ + "static/media/view.468c3206311faf4e2fd693d5c20b19e7.svg";
export { ForwardRef as ReactComponent };